export const bankLogosListConfig = {
  srcPath: '/lp/common/banks-logo/',
  brands: [
    'mastercard',
    'visa',
    'mifinity',
    'skrill',
    'neteller',
    'ecopayz',
    'maestro',
    'payeer',
    'interac',
    'piastrix',
    'idebit',
    'bitcoin',
    'siru-mobile',
    'ethereum',
  ],
  brandSizes: {
    mastercard: { width: 54, height: 38 },
    visa: { width: 80, height: 38 },
    mifinity: { width: 80, height: 38 },
    skrill: { width: 80, height: 38 },
    neteller: { width: 80, height: 38 },
    ecopayz: { width: 89, height: 24 },
    maestro: { width: 65, height: 26 },
    payeer: { width: 80, height: 38 },
    interac: { width: 64, height: 32 },
    piastrix: { width: 84, height: 34 },
    idebit: { width: 46, height: 23 },
    bitcoin: { width: 80, height: 38 },
    'siru-mobile': { width: 45, height: 28 },
    ethereum: { width: 54, height: 38 },
  },
};
